import { CommonModule } from '@angular/common';
import { Component, ElementRef, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Router } from '@angular/router'; // Importação do serviço de roteamento
import { SectionMainComponent } from './sections/section-main/section-main.component';
import { sectionPlanosComponente } from './sections/section-planos/section-planos.component';
import { SectionTabelaBeneficiosComponent } from './sections/section-tabela-beneficios/section-tabela-beneficios.component';
import { SectionProximoConfrontoComponent } from './sections/section-proximo-confronto/section-proximo-confronto.component';
import { SectionBannersComponent } from './sections/section-banners/section-banners.component';
import { SectionConteudoExclusivoComponent } from './sections/section-conteudo-exclusivo/section-conteudo-exclusivo.component';
import { SectionVideoComponent } from './sections/section-video/section-video.component';
import { SectionCarouselBeneficiosComponent } from './sections/section-carousel-beneficios/section-carousel-beneficios.component';
import { SectionRankingComponent } from './sections/section-ranking/section-ranking.component';
import { SectionFaqComponent } from './sections/section-faq/section-faq.component';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { SectionMainCearaComponent } from "./sections/section-main-ceara/section-main-ceara.component";
import { SectionProximoConfrontoCearaComponent } from "./sections/section-proximo-confronto-ceara/section-proximo-confronto-ceara.component";
import { SectionPlanosCearaComponent } from "./sections/section-planos-ceara/section-planos-ceara.component";
import { SectionCarouselBeneficiosCearaComponent } from "./sections/section-carousel-beneficios-ceara/section-carousel-beneficios-ceara.component";
import { SectionConteudoExclusivoCearaComponent } from "./sections/section-conteudo-exclusivo-ceara/section-conteudo-exclusivo-ceara.component";
import { AuthService } from 'src/app/core/services/auth.service';

@Component({
  selector: 'app-home',
  standalone: true,
  imports: [
    CommonModule,
    SectionMainComponent,
    sectionPlanosComponente,
    SectionTabelaBeneficiosComponent,
    SectionProximoConfrontoComponent,
    SectionBannersComponent,
    SectionConteudoExclusivoComponent,
    SectionVideoComponent,
    SectionCarouselBeneficiosComponent,
    SectionRankingComponent,
    SectionFaqComponent,
    SectionMainCearaComponent,
    SectionProximoConfrontoCearaComponent,
    SectionPlanosCearaComponent,
    SectionCarouselBeneficiosCearaComponent,
    SectionConteudoExclusivoCearaComponent
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit, OnDestroy {

  enableWhatsappButton = localStorage.getItem('enableWhatsappButton') === 'true';
  whatsappLink: SafeUrl;
  isCeara = this.authService.isCeara;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private sanitizer: DomSanitizer,
    private router: Router, // Injeta o Router no construtor
    private authService: AuthService
  ) { }

  ngOnInit() {
    this.redirectIfUserLoggedIn();
    this.changeParentContainerClass();
    this.setWhatsappLink();
  }

  ngOnDestroy() {
    this.restoreParentContainerClass();
  }

  private setWhatsappLink() {
    const link = localStorage.getItem('whatsappLink');
    if (link) {
      this.whatsappLink = this.sanitizer.bypassSecurityTrustUrl(link.replace(/"/g, ''));
    }
  }

  private redirectIfUserLoggedIn() {
    if (localStorage.getItem('current-user')) {
      const currentUser = JSON.parse(localStorage.getItem('current-user') || '{}');
      if (currentUser.isDependent) {
        this.router.navigate(['/dashboard-dependente']);
        return;
      }
      this.router.navigate(['/dashboard']);
    }
  }

  private changeParentContainerClass() {
    const parent = this.el.nativeElement.parentElement;
    if (parent) {
      this.renderer.removeClass(parent, 'container');
    }
  }

  private restoreParentContainerClass() {
    const parent = this.el.nativeElement.parentElement;
    if (parent) {
      this.renderer.addClass(parent, 'container');
    }
  }
}
